import React from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark, BookmarkBorder, MenuBook } from "@mui/icons-material";
import { CourseCardContainer } from "../style/components/CourseCard.jsx";
import { getRandomColor } from "../utils/helper";

const CourseCard = ({ course, onToggleBookmark }) => {
  const navigate = useNavigate();

  const truncateText = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };

  return (
    <CourseCardContainer>
      <div className="course-image" style={{ backgroundColor: getRandomColor(course.id) }}>
        {course.thumbnail ? <img src={course.thumbnail} alt={course.name} className="thumbnail" loading="lazy"/> : <MenuBook className="course-icon" />}
      </div>

      <div className="course-content">
        <h2 className="course-title">{course.name}</h2>
        <p className="course-description">{truncateText(course.description, 50)}</p>
        <div className="course-meta">
          <div className="category-tag">{course.category}</div>
        </div>
      </div>

      <div className="course-actions">
        {course.moduleId !== null ? (
          <button className="action-btn" onClick={() => navigate(`/exam`, { state: { courseId: course.id, moduleId: course.moduleId } })}>
            Take Exam
          </button>
        ) : (
          <button className="action-btn" onClick={() => navigate(`/course/${course.id}`)}>
            View Course
          </button>
        )}
        {course.saved !== null && (
          <button
            className={`bookmark-btn ${course.saved ? "bookmarked" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              onToggleBookmark();
            }}
            aria-label={course.saved ? "Remove bookmark" : "Add bookmark"}
          >
            {course.saved ? <Bookmark /> : <BookmarkBorder />}
          </button>
        )}
      </div>
    </CourseCardContainer>
  );
};

export default CourseCard;
